import React from 'react';
import PropTypes from 'prop-types';
import { Card, Badge, Spinner, EmptyState, Plus } from '@opendate-app/setlist';

function dueChip(dueAt) {
  if (!dueAt) return { label: 'No date', color: 'gray' };
  const due = new Date(dueAt);
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const d = new Date(due); d.setHours(0, 0, 0, 0);
  const days = Math.round((d - today) / 86400000);
  if (days < 0) return { label: 'Overdue', color: 'error' };
  if (days === 0) return { label: 'Today', color: 'orange' };
  if (days === 1) return { label: 'Tomorrow', color: 'gray' };
  return { label: due.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }), color: 'gray' };
}

function MyTasks({ tasks, teamId, loading }) {
  const rows = tasks || [];
  return (
    <Card padding="md">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <strong>My tasks</strong>
        <a href={`/teams/${teamId}/crm/tasks?view=my`}>View all</a>
      </div>

      {loading && <div className="d-flex justify-content-center py-4"><Spinner label="Loading…" /></div>}

      {!loading && rows.length === 0 && (
        <EmptyState
          size="sm"
          title="No tasks"
          description="Tasks you create or are assigned appear here with due dates."
          primaryAction={{ label: 'New task', icon: Plus, onClick: () => { window.location.href = `/teams/${teamId}/crm/tasks?action=new`; } }}
        />
      )}

      {!loading && rows.map((t) => {
        const chip = dueChip(t.due_at);
        return (
          <div key={t.id} className="crm-dash__row">
            <div className="crm-dash__truncate">
              <a href={t.href}>{t.title}</a>
            </div>
            <Badge color={chip.color}>{chip.label}</Badge>
          </div>
        );
      })}
    </Card>
  );
}

MyTasks.propTypes = {
  tasks: PropTypes.arrayOf(PropTypes.object),
  teamId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  loading: PropTypes.bool,
};

export default MyTasks;
